import {FieldEvent} from './settings';
import {updateDirty} from '../../common/fields';
import {resetRender} from './render';
import {cr} from 'fire-wind-water';

export function getFieldValue() {
  const result = updateDirty(FieldEvent);
  // 验证不通过时，渲染一下组件
  if (!result.isVerify) {
    resetRender();
  }
  return result;
}

export function clearFieldValue() {
  cr.each(FieldEvent, d => {
    d.clearValue();
  });
}